export enum AuthSignInStep {
    SUCCESS = "SUCCESS",
    CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
    UNKNOWN = "UNKNOWN",
}
